export const adaptPhoneNumber = phoneNumber => {
  let adaptedPhone = null;

  adaptedPhone = phoneNumber.replace(/[()-]/g, "");

  return adaptedPhone;
};

export const adaptDateOfBirth = dateOfBirth => {
  let adaptedDateOfBirth = null;
  let month = null;
  let day = null;
  let year = null;

  if (dateOfBirth) {
    month = dateOfBirth.substr(0, 2);
    day = dateOfBirth.substr(3, 2);
    year = dateOfBirth.substr(6, 4);
  }

  adaptedDateOfBirth = `${year}-${month}-${day}`;

  return adaptedDateOfBirth;
};
